export const MERCHANT_LOGO_TEST_ID = 'MerchantLogo';
export const MERCHANT_LOGO_IMAGE_TEST_ID = 'MerchantLogoImage';
export const MERCHANT_LOGO_LOADING_TEST_ID = 'MerchantLogoLoading';
export const MERCHANT_LOGO_PLACEHOLDER_TEST_ID = 'MerchantLogoPlaceholder';
